module.exports = require('./lib/react-emojione');



//////////////////
// WEBPACK FOOTER
// ./~/react-emojione/index.js
// module id = 3
// module chunks = 0